import { Component } from 'react'

import ReactDom from 'react-dom' ;

class DisplayObject extends Component
{
    get element()
    {
        const { element } = this.state ;
        return element ;
    }

    mounted = false ;

    state =
    {
        element : null ,
        mounted : false
    } ;

    componentDidMount()
    {
        this.mounted = true ;
        this.setState( { ...this.state , element : ReactDom.findDOMNode(this) , mounted : true } )  ;
    }

    componentWillUnmount()
    {
        this.mounted = false ;
        this.setState( { ...this.state , element : null , mounted : false } )  ;
    }
}

export default DisplayObject ;


// WEBPACK FOOTER //
// ./src/app/display/DisplayObject.js